<template>
  <div class="lemon flex-center-center flex-col">
    <h1>
      Bonjour {{ firstname }},<br />Etes-vous satisfaits du service Delicorner ?
    </h1>

    <div class="moodContainer flex">
      <img
        alt=""
        class="lemonImg"
        src="/svg/moods/mood-1.svg"
        @click="onClick('sad')"
      />
      <img
        alt=""
        class="lemonImg"
        src="/svg/moods/mood-2.svg"
        @click="onClick('neutral')"
      />
      <img
        alt=""
        class="lemonImg"
        src="/svg/moods/mood-3.svg"
        @click="onClick('happy')"
      />
    </div>

    <img alt="" class="greenLogo" src="/svg/logo--white.svg" />
  </div>
</template>

<script>
import { api, API_ROUTES } from "@/Services/api.common.service";
import { mapState } from "vuex";

export default {
  computed: mapState({
    firstname: (state) => state.account.firstname,
  }),
  methods: {
    async onClick(mood) {
      try {
        await api().put(API_ROUTES.mood.mood, { mood });
        await this.$router.push({ name: "home" });
        this.$notify({
          group: "all",
          type: "success",
          title: "Merci !",
        });
      } catch (e) {
        if (e?.response?.data?.error?.type === "mood_already_known") {
          await this.$router.push({ name: "home" });
          this.$notify({
            group: "all",
            type: "success",
            title: "Merci !",
          });
        } else {
          this.$notify({
            group: "all",
            type: "warn",
            title: "Une erreur s'est produite",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: white;
  font-size: 40px;
  text-align: center;
}

.lemon {
  background: var(--main-green);
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;
}

.moodContainer {
  margin-top: 100px;
  max-height: 350px;
}

.lemonImg {
  cursor: pointer;
  margin: 0 50px;
  max-height: 250px;
  width: 250px;
}

.greenLogo {
  bottom: 10px;
  left: 0;
  position: absolute;
  transform: rotate(40deg);
  width: 200px;
}
</style>
